import React from "react"
import { Box, BoxProps, Modal as MuiModal, ModalProps } from "@mui/material"
import { useMediaQuery } from "react-responsive"

type Props = ModalProps & {
  containerProps?: BoxProps
}

export const Modal: React.FC<Props> = ({ containerProps, children, ...rest }) => {
  const isPC = useMediaQuery({ query: "(min-width: 650px)" })

  const sx = containerProps || {}

  return (
    <MuiModal {...rest} disableAutoFocus={true}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: isPC ? 600 : "98vw",
          maxHeight: "95vh",
          overflowY: "auto",
          bgcolor: "#FFF",
          boxShadow: 24,
          borderRadius: isPC ? "20px" : "10px",
          p: isPC ? "30px" : "10px",
          ...sx,
        }}
      >
        {children}
      </Box>
    </MuiModal>
  )
}
